import { Grid } from '@chakra-ui/react'
import { Inbox, Timer, ShieldCheck } from 'lucide-react'
import type { HelpdeskDashboardStats } from '@/lib/services/helpdeskDashboardService'
import DashboardStatCard from './DashboardStatCard'
import { formatFirstResponseTime } from './formatters'

type Props = {
  stats: HelpdeskDashboardStats
  loading?: boolean
}

export default function TicketPulseStrip({ stats, loading }: Props) {
  return (
    <Grid templateColumns={{ base: '1fr', sm: 'repeat(3, 1fr)' }} gap={2.5} w="100%" minW={0}>
      <DashboardStatCard
        label="Received"
        value={stats.received}
        loading={loading}
        labelColor="blue.700"
        accent="blue.300"
        icon={<Inbox size={16} strokeWidth={2} />}
      />
      <DashboardStatCard
        label="Avg first response"
        value={formatFirstResponseTime(stats.average_first_response_seconds)}
        loading={loading}
        labelColor="blue.700"
        accent="teal.300"
        icon={<Timer size={16} strokeWidth={2} />}
      />
      <DashboardStatCard
        label="Resolution within SLA"
        value={`${Number(stats.resolution_within_sla_percent ?? 0).toFixed(1)}%`}
        loading={loading}
        labelColor="blue.700"
        accent="green.300"
        icon={<ShieldCheck size={16} strokeWidth={2} />}
      />
    </Grid>
  )
}
